import { HOMEPAGE_PAGE_KEY } from '@/views/Homepage/constants';

const pt = {
  [HOMEPAGE_PAGE_KEY]: {
    SEO_TITLE: 'Desenvolvemos talentos na sua empresa',
    SEO_DESCRIPTION:
      'Somos a plataforma tudo em um para cada um de seus desafios de gerenciamento humano.',

    SEO_CATEGORIES_TITLE: 'Categorias',
    SEO_SUBCATEGORIES_TITLE: 'Subcategorias',
    SEO_SOFTWARES_TITLE: 'Softwares',
    SEO_TRACKS_TITLE: 'Especializações',
    SEO_SEE_MORE: 'Ver mais',
    SEO_SEE_LESS: 'Ver menos',

    HERO_TITLE: 'Desenvolvemos talentos na sua empresa',
    HERO_SUBTITLE:
      'Na Crehana, agora também capacitamos equipes por meio de soluções de aprendizado e gestão de talentos',
    HERO_CTA: 'Comece agora',
    HERO_CTA_VARIANT: 'Solicitar Demo',
    HERO_LINK: 'Fale com um assessor',

    COMPANIES_LOGOS_TITLE: '+1000 empresas',
    COMPANIES_LOGOS_SUBTITLE: 'Confiam em nós',

    BANNER_TITLE:
      'Você pode escolher todas as rotas ou apenas as que você precisa.',
    BANNER_LINK: 'Quero saber mais',

    PREFOOTER_TITLE: 'Comece a construir equipes mais competitivas hoje mesmo',
    PREFOOTER_SUBTITLE:
      'Experimente de graça, por 7 dias, a nossa plataforma de gestão do aprendizado.',
    PREFOOTER_CTA: 'Comece agora',
    PREFOOTER_LINK: 'Fale com um assessor',

    PRODUCT_TAB1: 'Upskilling & Reskilling',
    PRODUCT_TAB2: 'Gestão da aprendizagem',
    PRODUCT_TAB3: 'Gestão do Talento',
    PRODUCT_TAB4: 'Dados e relatórios em tempo real',

    PRODUCT_TITLE1: 'Uma plataforma',
    PRODUCT_TITLE2: 'All-in-One',
    PRODUCT_TITLE3: 'para auxiliar nos desafios da gestão de pessoas',

    PRODUCT_TAB1_TITLE: 'Upskilling & Reskilling',
    PRODUCT_TAB1_DESCRIPTION:
      'Prepare a sua equipe para os desafios de hoje e do futuro, potencializando suas habilidades atuais e desenvolvendo seu talento para que se destaquem.',
    PRODUCT_TAB1_CARD1:
      '+1000 cursos online com a melhor produção audiovisual da América Latina.',
    PRODUCT_TAB1_CARD2:
      '+20 Academias com os assuntos mais solicitados pelo mercado de trabalho.',
    PRODUCT_TAB1_CARD3:
      'Vendas, Marketing, Data Analytics, Liderança, Soft Skills, e muito mais.',
    PRODUCT_TAB1_CARD4: 'Mentoria personalizada.',
    PRODUCT_TAB1_CARD5:
      'Profissionais de empresas líderes, que ensinam a partir da sua experiência.',
    PRODUCT_TAB2_TITLE: 'Gestão da aprendizagem',
    PRODUCT_TAB2_DESCRIPTION:
      ' Com o nosso LMS, não é preciso administrar várias plataformas! Gerencie todos os seus recursos de aprendizagem e desenvolvimento de talentos em um só lugar. Facilite a experiência da sua equipe e torne o seu trabalho mais simples.',
    PRODUCT_TAB2_CARD1:
      'A sua empresa tem seus próprios recursos? Carregue-os ao painel da Crehana!',
    PRODUCT_TAB2_CARD2: 'Crie e agende sessões ao vivo.',
    PRODUCT_TAB2_CARD3:
      'Elabore avaliações para medir a aprendizagem da sua equipe.',
    PRODUCT_TAB2_CARD4:
      'Integre seus próprios fornecedores e garanta conteúdos em uma única plataforma.',
    PRODUCT_TAB3_TITLE: 'Gestão do Talento',
    PRODUCT_TAB3_DESCRIPTION:
      'Agilize a maneira de medir o desempenho e o engajamento dos seus colaboradores. Analise a sua cultura organizacional e crie planos para fortalecê-la.',
    PRODUCT_TAB3_CARD1:
      'Objetivos: Gerenciar os KPIs e OKRs de cada pessoa, sem complicações.',
    PRODUCT_TAB3_CARD2:
      'Incentive a cultura do reconhecimento e feedback em sua equipe. ',
    PRODUCT_TAB3_CARD3:
      'Clima organizacional: Identifique a satisfação das suas equipes e crie planos para garantir bem estar e retenção',
    PRODUCT_TAB4_TITLE: 'Dados e relatórios em tempo real',
    PRODUCT_TAB4_DESCRIPTION:
      'Não podemos aprimorar o que não medimos. Fortaleça a sua estratégia com relatórios em tempo real, usando métricas e dados-chave sobre o talento da sua empresa.',
    PRODUCT_TAB4_CARD1:
      'Meça as habilidades atuais das equipes, com o Skill XP, e entenda o que elas precisam para crescer.',
    PRODUCT_TAB4_CARD2: 'Métricas claras, objetivas e de fácil análise.',
    PRODUCT_TAB4_CARD3: 'Relatórios descarregáveis gerados em tempo real.',
    PRODUCT_TAB4_CARD4: 'Compartilhe os resultados com outros líderes.',

    COMPANIES_TITLE1: '+1000 empresas',
    COMPANIES_TITLE2: 'desenvolvem seu talento com a gente',

    LEADERS_TITLE: 'Os líderes da América Latina recomendam a Crehana',
    LEADERS_ROLE1: 'Coordinadora de Aprendizaje en Entel Perú.',
    LEADERS_ROLE2:
      'Diretor Regional de Talento Humano na SURA Asset Management',
    LEADERS_ROLE3: 'HR Manager na Bioderma.',

    LEADERS_STORY1:
      'Nossa experiência com a Crehana foi excelente. Não só pelo conteúdo da plataforma, mas também pelo contato e pela flexibilidade que nos deram para usar as licenças. Gostei muito dos cursos, o timing de cada parte foi perfeito e sinto que os exemplos e explicações foram muito bons. A plataforma é amigável, fácil de usar e intuitiva.',
    LEADERS_STORY2:
      'As aulas da Crehana mudaram minha perspectiva sobre microlearning, prefiro chamar de fragmentação visualmente ergonômica do conhecimento. Você pode facilmente ouvir 50 minutos sem senti-los.',
    LEADERS_STORY3:
      'Somos muito gratos pela oportunidade, nossos colaboradores a receberam com muito entusiasmo e motivação, pois os temas são muito bons, atuais e contribuem muito para o desenvolvimento de nossa gente. Do ponto de vista do RH, a Crehana é uma aliada estratégica para a construção de planos de desenvolvimento e treinamento, retenção de talentos, reconhecimento e incentivo.',

    WHY_CREHANA_TITLE: 'Por que a Crehana?',

    WHY_CREHANA_CARD_TITLE_1:
      'Desenvolvemos uma plataforma que responde às suas necessidades',
    WHY_CREHANA_CARD_DESCRIPTION_1:
      'Sabemos que uma boa experiência depende de sua facilidade de uso e de um bom design. Nós dois temos!',
    WHY_CREHANA_CARD_TITLE_2: 'Criamos soluções pensando no que você precisa',
    WHY_CREHANA_CARD_DESCRIPTION_2:
      'Acompanhamos você em cada etapa, escutando, entendendo e enfrentando os desafios que vierem, com soluções pensadas para as necessidades da sua equipe.',
    WHY_CREHANA_CARD_TITLE_3: 'Nossas equipes estão realmente perto de você',
    WHY_CREHANA_CARD_DESCRIPTION_3:
      'A Crehana nasceu na América Latina, tendo equipes no México, Peru, Colômbia, Brasil e +8 países, com pessoas que falam o seu idioma e entendem os seus desafios com mais facilidade.',
    WHY_CREHANA_CARD_TITLE_4: 'Estamos há +7 anos desenvolvendo +6M pessoas',
    WHY_CREHANA_CARD_DESCRIPTION_4:
      'Mais de 81% das pessoas que aprendem com a gente aplicam seus aprendizados no trabalho.',
    VIDEO_SECTION_TITLE: 'O que é Crehana?',
    VIDEO_SECTION_VIDEO_OVERLAY_TEXT: 'Conheça Crehana em 1 minuto',
  },
};

export default pt;
